
import Vue from "vue";
import { LabelLayout } from "@/utils/label-layout/label-layout";
export default Vue.extend({
	props: {
		layout: {
			type: Object as ()=>LabelLayout,
			required: true
		},
	},
	computed: {
	},
	methods: {
		save(){
			this.$emit("save");
		}
	},
});
